import React from 'react';
import Icon from './Icon';

interface LinkButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

// Строка-ссылка в InfoTable: переход в другой раздел приложения.
const LinkButton: React.FC<LinkButtonProps> = ({ onClick, children }) => (
  <button
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: 0,
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--teal)',
      fontFamily: 'var(--sans)',
      fontSize: 14,
      fontWeight: 500,
      textAlign: 'left',
    }}
  >
    {children}
    <Icon name="chevron_right" size={15} color="var(--teal)" />
  </button>
);

export default LinkButton;
